import { render, staticRenderFns } from "./mainsupply.vue?vue&type=template&id=824f595a&scoped=true&"
import script from "./mainsupply.vue?vue&type=script&lang=js&"
export * from "./mainsupply.vue?vue&type=script&lang=js&"
import style0 from "./mainsupply.vue?vue&type=style&index=0&id=824f595a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824f595a",
  null
  
)

export default component.exports